'use client'

import React, { useState } from 'react'

import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react'

export enum CustomersSearchFilterSearchOption {
  default = 'default',
  user = 'user',
  contactAddress = 'contactAddress',
  billingAddress = 'billingAddress',
}

interface CustomersSearchFormTypes {
  searchText: string
  searchOption: CustomersSearchFilterSearchOption
  pageSize: number
  currentPage: number
}

interface CustomersSearchFilterContextProps {
  formData: CustomersSearchFormTypes | null
  setFormData: Dispatch<SetStateAction<CustomersSearchFormTypes>>
}

const CustomersListFilterContext = React.createContext<CustomersSearchFilterContextProps>({
  formData: null,
  setFormData: () => null,
})

const CustomersSearchFilterContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [formData, setFormData] = useState<CustomersSearchFormTypes>({
    searchText: '',
    searchOption: CustomersSearchFilterSearchOption.default,
    pageSize: 20,
    currentPage: 0,
  })

  return (
    <CustomersListFilterContext.Provider
      value={{
        formData,
        setFormData,
      }}
    >
      {children}
    </CustomersListFilterContext.Provider>
  )
}

export default CustomersSearchFilterContextProvider
